<script lang="ts">
  import Icon from './Icon.svelte';
  import type { AutoGroup } from '~/shared/auto-groups.js';

  let {
    group,
    onShowOnMap,
    onViewList,
  }: {
    group: AutoGroup;
    onShowOnMap: (group: AutoGroup) => void;
    onViewList: (group: AutoGroup) => void;
  } = $props();

  const empty = $derived(group.members.length === 0);
</script>

<section class="card-group">
  <header class="head">
    <div class="title">
      <span class="dot dot--{group.tint}" aria-hidden="true"></span>
      <h3 class="m-0 truncate">{group.name}</h3>
      <span class="count">{group.members.length} {group.members.length === 1 ? 'place' : 'places'}</span>
    </div>
  </header>

  <div class="actions">
    <button
      class="btn btn-secondary"
      type="button"
      disabled={empty}
      onclick={() => onShowOnMap(group)}
    >
      <Icon name="map" size={15} />
      <span>Show on map</span>
    </button>
    <button
      class="btn btn-secondary"
      type="button"
      disabled={empty}
      onclick={() => onViewList(group)}
    >
      <Icon name="list" size={15} strokeWidth={2} />
      <span>View list</span>
    </button>
  </div>
</section>

<style>
  .card-group {
    background: var(--color-canvas);
    border: 1px solid var(--color-hairline-soft);
    border-radius: var(--radius-md);
    padding: 1rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }
  .title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
    flex: 1;
  }
  .title h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-ink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .count {
    font-size: 13px;
    color: var(--color-muted);
    flex: none;
  }
  .actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  .actions button { flex: 1; min-width: 120px; }
  .actions button:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
